import { Select } from '../ui';

type DateBasis = 'invoiceDate' | 'paymentDate';
type PaymentStatus = 'all' | 'known' | 'unknown';

export function DateBasisControls({ dateBasis, paymentStatus, onBasisChange, onPaymentStatusChange }: {
  dateBasis: DateBasis;
  paymentStatus: PaymentStatus;
  onBasisChange: (basis: DateBasis) => void;
  onPaymentStatusChange: (status: PaymentStatus) => void;
}) {
  return (
    <div className="flex flex-wrap items-end gap-2">
      <div className="w-44">
        <Select label="Datumsbasis" value={dateBasis} onChange={(event) => onBasisChange(event.target.value as DateBasis)} options={[
          { value: 'invoiceDate', label: 'Rechnungsdatum' },
          { value: 'paymentDate', label: 'Zahlungsdatum' },
        ]} />
      </div>
      {dateBasis === 'paymentDate' && <div className="w-52">
        <Select label="Zahlungstag" value={paymentStatus} onChange={(event) => onPaymentStatusChange(event.target.value as PaymentStatus)} options={[
          { value: 'all', label: 'Alle' }, { value: 'known', label: 'Bekannt' },
          { value: 'unknown', label: 'Unbekannt · ohne Zeitraum' },
        ]} />
      </div>}
    </div>
  );
}
